<template>
  <a-drawer
    :open="open"
    width="500"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    @close="close"
  >
    <div>
      <Text :type="'subHeader'" :text="'Edit Product'" />

      <Text
        :type="'textFadedMedium'"
        :text="'Edit any of the selected product'"
      />
    </div>
    <div class="mt-4">
      <!-- <Text type="form-label" :text="'Select product and limit'" /> -->
      <form @submit.prevent="handleProductEdit">
        <div class="mt-3">
          <LabelText :forVal="'productSelect'" :labelText="'Select product'" />
          <input
            class="w-full px-4 py-2 border-[1px] text-base bg-transparent rounded-lg border-grey300 font-quietSans placeholder-grey500 outline-foundationGrey500 focus:border-foundationGrey500"
            name="name"
            :value="productObject.depotProductName"
            readonly
          />
        </div>
        <div class="mt-3">
          <LabelText
            :forVal="'product_volume'"
            :labelText="'Maximum volume:'"
          />

          <input
            class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
            :placeholder="'50,000l'"
            :name="'maxCapacity'"
            :type="'text'"
            :value="productObject.maxCapacity"
            v-model="productObject.maxCapacity"
          />
        </div>

        <div class="mt-3">
          <LabelText
            :forVal="'current_volume'"
            :labelText="'Current volume:'"
          />

          <input
            class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
            :placeholder="'Enter new volume'"
            :name="'currentQuantity'"
            :type="'text'"
            :value="productObject.currentQuantity"
            v-model="productObject.currentQuantity"
          />
        </div>

        <!-- <div class="mt-3">
          <LabelText :forVal="'product_volume'" :labelText="'Product price:'" />

          <input
            class="w-full px-4 py-2 text-sm rounded-md border-[1px] border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
            :placeholder="'Set product price'"
            :name="'price'"
            :type="'text'"
            :value="productObject.price"
            v-model="productObject.price"
          />
        </div>

        <div class="mt-3">
          <LabelText :forVal="'startDate'" :labelText="'Price start date:'" />
          <VueDatePicker
            color="#00903a"
            name="startDate"
            input-size="sm"
            :min-date="todayDate"
            no-label
            v-model="startDate"
            format="YYYY-MM-DDTHH:mm:ss"
          />
        </div>

        <div class="mt-3">
          <LabelText :forVal="'date'" :labelText="'Price end date:'" />
          <VueDatePicker
            color="#00903a"
            input-size="sm"
            name="endDate"
            :min-date="todayDate"
            v-model="endDate"
            format="YYYY-MM-DDTHH:mm:ss"
          />
        </div> -->

        <div
          v-if="depotProducts?.length > 1"
          class="flex items-center my-2 cursor-pointer"
          @click="addProduct"
        >
          <span><img src="@/assets/svg/addGreen.svg" /></span>
          <p class="ml-2 text-sm text-primaryGreen">Add more product</p>
        </div>

        <div class="mt-4">
          <FormSubmitInput :loading="loading" :val="'Edit product'" />
        </div>
      </form>
    </div>
  </a-drawer>
</template>

<script>
//services
import depotService from "@/services/depot-service";
import utilityService from "@/services/utility-service.js";

//libraries
import moment from "moment";
import { useToast } from "vue-toastification";

//components
import Text from "@/components/UI/Text/Text.vue";
import LabelText from "@/components/UI/Text/LabelText.vue";
import CheckInput from "@/components/UI/Inputs/CheckInput.vue";
import DrawerInput from "@/components/UI/Inputs/DrawerInput.vue";
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
import SelectWrapper from "@/components/UI/Selects/DrawerSelect.vue";
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";
import FormSubmitInput from "@/components/UI/Inputs/FormSubmitInput.vue";
import AddProductDepot from "@/components/pages/Depot/AddProductDepot.vue";
import FadedBorderWrapper from "@/components/UI/Wrappers/FadedBorderWrapper.vue";
import CreateDepotGroupModalVue from "@/components/pages/Depot/Modal/DepotGroupModal.vue";
import stripNonNumber from "@/utils/stripNonNumber.js";

export default {
  props: [
    "open",
    "close",
    "getDepot",
    "depotGroups",
    "getDepotGroups",
    "productObject",
    "callEndPoints",
  ],
  components: {
    CreateDepotGroupModalVue,
    Text,
    DrawerInput,
    AddProductDepot,
    LabelText,
    SelectWrapper,
    FadedBorderWrapper,
    FlexWrapper,
    CheckInput,
    SubmitButton,
    FormSubmitInput,
  },
  data() {
    return {
      toast: useToast(),
      todayDate: moment().format("YYYY-MM-DD"),
      productVolume: "",
      productName: "",
      // newPrice: "",
      // startDate: "",
      // endDate: "",
      productPrice: "",
      newVolume: "",
      loading: false,
    };
  },
  methods: {
    async handleProductEdit(e) {
      const data = Object.fromEntries(new FormData(e.target));

      // data.endDate = moment(data.endDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
      // data.startDate = moment(data.startDate).format(
      //   "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
      // );
      if (parseFloat(data.currentQuantity) > parseFloat(data.maxCapacity)) {
        this.toast.error(
          "Current volume can't be higher than maximum capacity"
        );
        return;
      }

      // console.log(data, "dskjds");
      let depotId = new URLSearchParams(window.location.search);

      this.loading = true;
      try {
        const result = await depotService.editProductSale(depotId.get("id"), [
          {
            ...data,
            maxCapacity: +stripNonNumber(data.maxCapacity),
            // price: +stripNonNumber(data.price),
            currentQuantity: +stripNonNumber(data.currentQuantity),
            productSaleId: this.productObject.id,
            productId: this.productObject.id,
          },
        ]);

        this.callEndPoints();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.productVolume = this.productObject.maxCapacity;
    this.productName = this.productObject.depotProductName;
  },
};
</script>

<style></style>
